import type { ReactElement, ReactNode } from 'react';
import { Progress, ProgressBar } from '@ff-it/ui';
import cx from 'clsx';
import './InvoicingProgress.scss';
import type { InvoiceDirection } from 'modules/invoicing/common/types';

type InvoicingProgressProps = {
  direction: InvoiceDirection;
  ratio: number | null;
  children?: ReactNode;
  id?: string;
  // total
  // bound
  // remainder
};

// clamp to min/max 10 % from edges to make obvious
const margin = 10;

export function InvoicingProgress({ direction, ratio, children, id }: InvoicingProgressProps): ReactElement {
  const empty = ratio === null;
  let width = 0;
  if (ratio !== null) {
    if (ratio > 0 && ratio < margin) {
      width = margin;
    } else if (ratio > 100 - margin && ratio < 100) {
      width = 100 - margin;
    } else {
      width = ratio;
    }
  }

  return (
    <Progress
      className={cx(`invoicing-progress invoicing-progress--${direction}`, {
        'invoicing-progress--empty': empty,
      })}
      data-tooltip-id={id}
    >
      {!empty && (
        <ProgressBar
          className={`invoicing-progress__bar invoicing-progress__bar--${direction}`}
          value={width}
          showValue={false}
          title=""
        >
          {children}
        </ProgressBar>
      )}
    </Progress>
  );
}
